import { WrappedBigNumber } from '@/entities/WrappedBigNumber';

export const WRAPPED_ZERO = WrappedBigNumber.from(0);
